// import { Link } from 'ice';
import { useEffect, useState } from 'react';
// import style from './index.module.scss';
import { footerData, footerLinkData, IFooterData } from './common';
// import cls from 'classnames';
import { cloneDeep } from 'lodash';
// import React from 'react';
import { useStore } from '@/store';
import { ClientHostType } from '@/types';
import DefaultFooter from './DefaultFooter';
import ACXFooter from './component/ACXFooter';
import ICIRENAFooter from './component/ICIRENAFooter';
// import GALAXYFooter from './component/GALAXYFooter';

// onResize
const useOnResize = () => {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWidth(document.body.clientWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return width;
};

export default function Footer(props) {
  const { value } = props;
  console.log('log_[value]==>', value);
  const screenWidth = useOnResize();
  const [isPcScreen, setIsPcScreen] = useState<boolean>(true);
  const [cloneFooterData, setCloneFooterData] = useState<IFooterData[]>(
    cloneDeep(footerData) as unknown as IFooterData[],
  );
  const { channel } = useStore();
  useEffect(() => {
    if (screenWidth >= 1024) {
      setIsPcScreen(true);
    } else {
      setIsPcScreen(false);
    }
  }, [screenWidth]);

  useEffect(() => {
    setCloneFooterData(
      [...cloneFooterData].map((item, index) => {
        if (index === 5) {
          isPcScreen
            ? (item.content = cloneDeep(footerData[index].content))
            : item.content.splice(4, 0, ...footerLinkData);
        }
        return item;
      }) as unknown as IFooterData[],
    );
  }, [isPcScreen]);

  // const handleToggle = (idx) => {
  //   if (screenWidth >= 1024 || idx === 5) return;
  //   setCloneFooterData(
  //     [...cloneFooterData].map((item, index) => {
  //       if (index === idx) {
  //         return {
  //           ...item,
  //           visible: !item.visible,
  //         };
  //       }
  //       return item;
  //     }) as unknown as IFooterData[],
  //   );
  // };
  console.log('channel---------', channel);
  // if (channel === ClientHostType.acx) {
  //   return <ACXFooter protocolList={value} />;
  // } else if (channel !== ClientHostType.galaxy) {
  //   return <DefaultFooter value={value} />;
  // }
  switch (channel) {
    case ClientHostType.acx:
      return <ACXFooter protocolList={value} />;
    case ClientHostType.icirena:
      return <ICIRENAFooter protocolList={value} />;
    case ClientHostType.galaxy:
      return null;
    default:
      return <DefaultFooter value={value} />;
  }
}
